export default {
  namespaced: true,
  inventory_brand_catalog: {
    menu: "Catálogo de marcas",
    title: "Marca",
    name: "Nome",
    created_at: "Criado em",
    updated_at: "Atualizado em",
  },
};
